import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-secure-upload-file-modal',
  templateUrl: './upload-file-modal.component.html'
})
export class UploadFileModalComponent implements OnInit {
  fileUploadForm: FormGroup = new FormGroup({});
  modalHeader: string;
  fileType: string;
  base64: string | ArrayBuffer;
  selectedFile: File;
  isSubmitDisabled: boolean = false;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    
  }


  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  upload() {
    if (!this.selectedFile){
       this.showErrorToast("Please Upload the File");
    }
     
    if (!this.base64){
      this.showErrorToast("Please Upload the File");
    }

    if (this.base64) {
      return this.modalCtrl.dismiss(this.base64);
    }
    else {
      
    }
  }

  onFileSelect(event) {
    this.isSubmitDisabled = true;
    this.selectedFile = event.target.files[0];
    console.log("Selected File in Modal >>>>> ", this.selectedFile);

    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile);
    reader.onload = () => {
      this.base64 =reader.result; 
      this.isSubmitDisabled = false;
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public space(event:any){

    if (event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
    }

}
